import React from 'react'
import styled from 'styled-components'
import { divergingLikert, LikertLegend, TableWrapper } from 'react-likert'
import Arrow from './down.png'
import megaPop from './megaPop'

const scale = [
  'Strongly Disagree',
  'Disagree',
  'Undecided',
  'Agree',
  'Strongly Agree',
]

const options = {
  usePatterns: false,
  colors: ['#eeeeee', ['#FEFF00', '#FF0000'], ['#92D04F', '#06B04F']],
}

class ReportWrapper extends React.Component {
  state = {
    filter: '',
    vs: 'UA',
  }

  handleChange = evt => {
    const target = evt.target

    this.setState(state => ({
      filter: target.innerText,
    }))
    console.log(target.innerText)
  }

  handleSelect = evt => {
    const target = evt.target

    this.setState(state => ({
      vs: target.value,
    }))
    console.log(target.value)
  }

  reset = () => {
    this.setState(state => ({
      filter: '',
    }))
  }

  render(props) {
    const { filter, vs } = this.state
    const group = this.props.group
    const meanSort = obj =>
      obj.sort((a, b) => (a.mean < b.mean ? 1 : b.mean < a.mean ? -1 : 0))
    const mp = megaPop(this.props.data)
    const topics = meanSort(mp)
    const data = meanSort(this.props.data)

    const likertData = filter.length > 1 ? data : topics
    const topicFilter = this.state.filter
      ? likertData.filter(d => d.topic === filter)
      : likertData

    const alternating = topicFilter.reduce(
      (alt, d) => alt.concat([{ ...d, SUG: false }, { ...d, SUG: true }]),
      []
    )
    const groupDict = {
      UA: 'UA Overall',
      SUG: 'SUG Overall',
      UA2: group != 'Faculty' ? 'Other UA Staff' : 'UA Staff',
    }
    return (
      <DivergingLikert
        key={filter || 'x'}
        likertData={likertData}
        filter={filter}
        group={group}
        groupDict={groupDict}
        vs={vs}
        handleSelect={this.handleSelect}
        handleChange={this.handleChange}
        reset={this.reset}
        topicFilter={topicFilter}
        alternating={alternating}
      />
    )
  }
}
const DivergingLikert = ({
  group,
  vs,
  groupDict,
  handleSelect,
  filter,
  handleChange,
  reset,
  alternating,
}) => (
  <div>
    {filter && filter.length > 1 ? (
      <Button onClick={reset}>{'← Go Back'}</Button>
    ) : null}
    <LikertLegend
      scale={scale.map((s, i) => `${s} (${i + 1})`)}
      inline={true}
      options={options}
      size={14}
      style={{ textAlign: 'right', marginBottom: '1em', float: 'right' }}
    />

    <TableWrapper
      key={vs}
      scale={scale}
      options={options}
      renderer={divergingLikert}
    >
      {CellRenderer => (
        <table className="demo">
          <caption>
            <h2 style={{ display: 'inline-block' }}>
              {`UA ${group} and `}
              <Select className="select" value={vs} onChange={handleSelect}>
                <option value="UA">{groupDict['UA']}</option>
                <option value="UA2">{groupDict['UA2']}</option>
              </Select>
            </h2>
            <h3>{filter || 'Response Distribution By Theme'}</h3>
          </caption>
          <Thead>
            <tr>
              {filter < 1 ? null : <th style={{ textAlign: 'left' }}>#</th>}
              <th style={{ textAlign: 'left' }}>
                {filter < 1 ? 'Theme' : 'Question'}
              </th>
              <th>&nbsp;</th>
              <th>
                Mean<br />(1-5)
              </th>
              <th style={{ width: '50%', paddingLeft: '110px' }}>
                Distribution
              </th>
            </tr>
          </Thead>
          <tbody>
            {alternating.map(
              (d, i) =>
                !d.SUG ? (
                  <tr key={`${i}_a`}>
                    {filter < 1 ? null : <td rowSpan="2">{d.q}</td>}
                    <td rowSpan="2">
                      {filter < 1 ? (
                        <a href="#" onClick={handleChange}>
                          {d.topic}
                        </a>
                      ) : (
                        d.question
                      )}
                    </td>
                    <td style={{ paddingLeft: '0.96667rem' }}>{group}</td>
                    <td>{d.mean}</td>
                    <CellRenderer
                      value={{
                        'Strongly Disagree': d.SD * 0.01,
                        Disagree: d.D * 0.01,
                        Undecided: d.U * 0.01,
                        Agree: d.A * 0.01,
                        'Strongly Agree': d.SA * 0.01,
                      }}
                    />
                  </tr>
                ) : (
                  <tr key={i}>
                    <td style={{ paddingLeft: '0.96667rem' }}>
                      {groupDict[vs]}
                    </td>
                    <td>{d[`${vs}_mean`]}</td>

                    <CellRenderer
                      value={{
                        'Strongly Disagree': d[`${vs}_SD`] * 0.01,
                        Disagree: d[`${vs}_D`] * 0.01,
                        Undecided: d[`${vs}_U`] * 0.01,
                        Agree: d[`${vs}_A`] * 0.01,
                        'Strongly Agree': d[`${vs}_SA`] * 0.01,
                      }}
                    />
                  </tr>
                )
            )}
          </tbody>
        </table>
      )}
    </TableWrapper>
  </div>
)

export default ReportWrapper

const Button = styled.button`
  margin-left: 1em;
  background: #fff;
  border: 1px solid #ccc;
  background-size: 400% 400%;
  color: #333;
  border-radius: 5px;
  -webkit-text-decoration: none;
  text-decoration: none;
  padding: 0.4em 1.5em;
  &:hover {
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.15);
    -webkit-animation: SpeedyGradient 3s ease infinite;
    animation: SpeedyGradient 3s ease infinite;
    color: #fff;
    background: #900;
  }
`

const Thead = styled.thead`
  @media print {
    display: table-row-group;
    page-break: avoid;
  }
`

const Select = styled.select`
  display: inline-block;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: bold;
  color: inherit;
  border: 0;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  font-size: 1.62671rem;
  line-height: 1.1;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url(${Arrow}) no-repeat right;
  -webkit-appearance: none;
  padding-right: 15px;
  background-position-x: 100%;
  &:hover {
    border-bottom: 1px solid #ccc;
  }
  @media print {
    white-space: normal;
    overflow: wrap;
    text-overflow: unset;
  }
`



// WEBPACK FOOTER //
// ./src/components/LikertRD.js